import { ColorTypes } from '@omegagrid/core';
import { msg } from "@omegagrid/localize";
import { FormAdapter, FormContainerOptions, FormControlType, FormControlProperties } from '@omegagrid/form';
import rp from '@reporting/rp-app-host';
import { url } from '@reporting/rp-mf-accounting';
import { User } from "@reporting/rp-types/core";

export class ForcePwdChangeFormAdapter extends FormAdapter {

	private url: string;
	private isActive: boolean = false;

	constructor(
		private user: User,
		private options?: FormContainerOptions
	) {
		super();
		this.url = this.user.password_change_token ? `${url.getBaseAuthUrl()}?pwd_change_token=${encodeURIComponent(this.user.password_change_token)}` : '';
		this.isActive = !!this.user.password_change_token;
	}

	getColumns() {
		return [
			{width: 80},
			{width: null},
		];
	}

	async getControls() {
		let r = 0;
		const rows: FormControlProperties[] = [
				{row: ++r, col: 0, type: FormControlType.Label, value: `URL`, for: 'url'},
				{row: r, col: 1, type: FormControlType.TextInput, key: 'url', value: this.url, readOnly: true}
			];
		return rows;
	}

	getOptions(): FormContainerOptions {
		return this.options || {
			caption: msg('Force password change'),
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [
				...(this.isActive && this.user.email ? [{
					key: 'sendMail',
					text: msg('Send email'),
					color: ColorTypes.Gray
				}] : []),
				{
					key: this.isActive ? 'deactivate' : 'activate',
					text: this.isActive ? msg('Deactivate') : msg('Activate'),
					color: this.isActive ? ColorTypes.Yellow : ColorTypes.Accent
				}
			],
		};
	}

	async onAction(action: string) {
		switch (action) {
			case 'sendMail':
				const command = await rp.host.openMenu({
					content: 'yes_no',
					text: `${msg('Are you sure you want to send email to')} '${this.user.email}'?`
				});
				if (command?.id == 'Y') {
					await rp.ms('users').post('sendPasswordMail', { user: this.user.user_name });
					rp.host.bucket.showAlert({ content: msg('Password reset email sent successfully.'), type: 'success' });
				}
				break;
			case 'activate': // Externally operated to perform updates on buttons etc.
				this.component.dispatchEvent(new CustomEvent('form.activate', {bubbles: true, composed: true}));
				break;
			case 'deactivate': // Externally operated to perform updates on buttons etc.
				this.component.dispatchEvent(new CustomEvent('form.deactivate', {bubbles: true, composed: true}));
				break;
		}
	}
};
